import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '@scripts/woo_services.module/AuthService';
import { OMS_BOOKABLE_CHECK_ENABLED } from '@scripts/woo_services.module/shared-types';
import { SystemService } from '@scripts/woo_services.module/SystemService';

export const InventoryAdminOnlyWhenOmsGuard: CanActivateFn = async (route) => {
  const authService = inject(AuthService);
  const systemService = inject(SystemService);
  // AuthGuard/RoleGuard already reject (and notify) these users
  if (!authService.isAuthenticated() || !authService.hasAnyRole(route.data.roles)) {
    return false;
  }
  if (authService.admin() || !(await systemService.isFeatureToggleOn(OMS_BOOKABLE_CHECK_ENABLED))) {
    return true;
  }
  authService.notAuthorized$.next();
  return false;
};
